import {Swiper} from 'swiper';
import { Navigation, Pagination, EffectFade, EffectCreative } from 'swiper/modules';

function timeline() {
    let timeline1 = document.querySelector('.swiper-timeline-slider-1');
    let timeline2 = document.querySelector('.swiper-timeline-slider-2');

    if (!timeline1 || !timeline2) return;

    let swiper1, swiper2;
    let currentStep = 0;

    const updateSliders = (step) => {
        currentStep = step;
        
        let swiper1Index, swiper2Index;
        
        if (step % 2 === 0) {
            // Even steps: Top shows 2, Bottom shows 1
            swiper1.params.slidesPerView = 2;
            swiper2.params.slidesPerView = 1;
            swiper1Index = Math.floor(step / 2);
            swiper2Index = Math.floor(step / 2);
        } else {
            // Odd steps: Top shows 1 (the SECOND item), Bottom shows 2
            swiper1.params.slidesPerView = 1;
            swiper2.params.slidesPerView = 2;
            swiper1Index = Math.floor(step / 2) + 1;
            swiper2Index = Math.floor(step / 2);
        }
        
        swiper1.update();
        swiper2.update();
        
        swiper1.slideTo(swiper1Index, 300);
        swiper2.slideTo(swiper2Index, 300);
        
        updateNavigationButtons();
    }

    const canGoNext = () => {
        // Calculate what the next step indices would be
        let nextStep = currentStep + 1;
        let nextSwiper1Index, nextSwiper2Index;
        
        if (nextStep % 2 === 0) {
            nextSwiper1Index = Math.floor(nextStep / 2);
            nextSwiper2Index = Math.floor(nextStep / 2);
            // Check if top slider would show slides beyond available
            return nextSwiper1Index + 1 < swiper1.slides.length;
        } else {
            nextSwiper1Index = Math.floor(nextStep / 2) + 1;
            nextSwiper2Index = Math.floor(nextStep / 2);
            // Check both sliders
            return nextSwiper1Index < swiper1.slides.length && 
                   nextSwiper2Index + 1 < swiper2.slides.length;
        }
    }

    const updateNavigationButtons = () => {
        const nextButton = document.querySelector('.swiper-button-next-timeline');
        const prevButton = document.querySelector('.swiper-button-prev-timeline');
        
        if (nextButton) {
            if (canGoNext()) {
                nextButton.classList.remove('swiper-button-disabled');
            } else {
                nextButton.classList.add('swiper-button-disabled');
            }
        }
        
        if (prevButton) {
            if (currentStep > 0) {
                prevButton.classList.remove('swiper-button-disabled');
            } else {
                prevButton.classList.add('swiper-button-disabled');
            }
        }
    }

    swiper1 = new Swiper(timeline1, {
        modules: [Pagination, Navigation, EffectCreative, EffectFade],
        slidesPerView: 2,
        spaceBetween: 24,
        allowTouchMove: false,
        effect: 'creative',
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        // fadeEffect: { crossFade: true },
        on: {
            init() {
                setEqualSlideHeights(this.el);
            },
            resize() {
                setEqualSlideHeights(this.el);
            },
        }
    });

    swiper2 = new Swiper(timeline2, {
        modules: [Pagination, Navigation, EffectCreative, EffectFade],
        slidesPerView: 1,
        spaceBetween: 24,
        allowTouchMove: false,
        effect: 'creative',
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        // fadeEffect: { crossFade: true },
        on: {
            init() {
                setEqualSlideHeights(this.el);
            },
            resize() {
                setEqualSlideHeights(this.el);
            },
        }
    });

    const nextButton = document.querySelector('.swiper-button-next-timeline');
    const prevButton = document.querySelector('.swiper-button-prev-timeline');

    if (nextButton) {
        nextButton.addEventListener('click', (e) => {
            e.stopPropagation();
            if (canGoNext()) {
                updateSliders(currentStep + 1);
            }
        });
    }

    if (prevButton) {
        prevButton.addEventListener('click', (e) => {
            e.stopPropagation();
            if (currentStep > 0) {
                updateSliders(currentStep - 1);
            }
        });
    }

    updateSliders(0);

    function setEqualSlideHeights(swiperEl) {
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        let maxHeight = 0;

        // Reset heights first
        slides.forEach(slide => {
            slide.style.height = 'auto';
        });

        // Find tallest slide in this swiper
        slides.forEach(slide => {
            maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });

        // Apply to all slides in this swiper
        slides.forEach(slide => {
            slide.style.height = `${maxHeight}px`;
        });
    }
}

export default timeline;